import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from '@i18n';
import Countdown from 'react-countdown';
import { Icon } from "@syarahtech/ui";
import { useLang } from "@/common/Contexts/LanguageContext";
import SAR from "@componentsShared/SAR/SAR";
import useHelpers from "@hooks/useHelpers";
var PromoPopup = function PromoPopup(_ref) {
  var onClose = _ref.onClose,
    promoCode = _ref.promoCode,
    onBookNow = _ref.onBookNow,
    onShow = _ref.onShow;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    isVisible = _useState[0],
    setIsVisible = _useState[1];
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard,
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  // Track promo view when component mounts
  useEffect(function () {
    if (promoCode) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [promoCode]);
  useEffect(function () {
    onShow === null || onShow === void 0 ? void 0 : onShow();
  }, []);
  var handleClose = useCallback(function () {
    setIsVisible(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  var handleBookNow = useCallback(function () {
    // Call the onBookNow callback which will handle the redirect
    setIsVisible(false);
    onBookNow === null || onBookNow === void 0 ? void 0 : onBookNow();
  }, [onBookNow, promoCode]);

  // Countdown renderer with exact styling
  var countdownRenderer = function countdownRenderer(_ref2) {
    var hours = _ref2.hours,
      minutes = _ref2.minutes,
      seconds = _ref2.seconds,
      completed = _ref2.completed;
    if (completed) {
      return /*#__PURE__*/React.createElement("span", {
        className: "tabular-nums"
      }, "00:00:00");
    }
    var formatTime = function formatTime(time) {
      return time.toString().padStart(2, "0");
    };
    return /*#__PURE__*/React.createElement("span", {
      className: "tabular-nums"
    }, hours, ":", minutes, ":", seconds);
  };
  var formatPrice = function formatPrice(price) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };
  var formatDiscountAmount = function formatDiscountAmount(amount) {
    return "".concat(formatPrice(amount));
  };

  // Calculate discounted price
  var getDiscountedPrice = function getDiscountedPrice() {
    var originalPrice = promoCode.car_details.price;
    return originalPrice - promoCode.discount_amount;
  };
  var discountedPrice = getDiscountedPrice();
  var carDetails = promoCode.car_details;

  // Exact measurements from the design
  var whiteBoxWidth = 345; // px
  var lang = useLang();
  if (!promoCode) return null;
  // on click on any place of popup, redirect to cardetails page
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 left-1/2 w-full md:w-[370px] mb-[88px] transform -translate-x-1/2 z-[99999] transition-all duration-300 ".concat(isVisible ? 'translate-y-0 opacity-100' : 'translate-y-[900px] opacity-0' + 'bg-black bg-opacity-50')
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative max-w-md font-bold z-[99999] "
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex flex-col items-center"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleClose,
    className: "absolute z-20 flex items-center justify-center bg-transparent border-2 border-[#3c56d4] text-[#3c56d4] rounded-full hover:bg-opacity-80 transition-colors cursor-pointer ar:left-[calc(50%-${whiteBoxWidth/2}px-12px)] en:right-[calc(50%-${whiteBoxWidth/2}px-12px)] ",
    style: _objectSpread({
      width: "24px",
      height: "24px",
      top: "-21px"
    }, lang === 'ar' ? {
      left: "calc(50% - ".concat(whiteBoxWidth / 2, "px - 12px)")
    } : {
      right: "calc(50% - ".concat(whiteBoxWidth / 2, "px - 12px)")
    })
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--cancel-outline-rounded",
    width: 10,
    height: 10
  })), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      navigateToHard(createUrlAbsolute('/cardetail/' + promoCode.post_id));
    },
    className: "bg-white rounded-lg text-[#484848] mx-auto flex flex-col overflow-hidden relative z-10 cursor-pointer ar:direction-rtl en:direction-ltr",
    style: {
      width: "".concat(whiteBoxWidth, "px"),
      height: "96px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow flex items-center p-2 pb-1 rounded-t-lg border border-solid border-gray-200",
    dir: lang === 'ar' ? 'rtl' : 'ltr'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 w-[82px] h-[56px] order-first"
  }, /*#__PURE__*/React.createElement("img", {
    src: carDetails.image_url,
    alt: lang == 'ar' ? carDetails.title_ar : carDetails.title_en,
    width: 82,
    height: 56,
    className: "object-contain w-full h-full rounded-lg",
    onError: function onError(e) {
      if (carDetails.images.length > 0) {
        e.target.src = carDetails.images[0];
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow flex flex-col justify-center ar:text-right en:text-left ar:pr-2 en:pl-2 gap-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-sm leading-tight"
  }, lang == 'ar' ? carDetails.title_ar : carDetails.title_en), /*#__PURE__*/React.createElement("div", {
    className: " flex justify-start gap-4 leading-tight text-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 justify-start max-w-[90px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6d7a8d] line-through h-auto"
  }, formatPrice(carDetails.price)), /*#__PURE__*/React.createElement(SAR, {
    className: "relative top-1 text-[#6d7a8d] px-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 justify-start max-w-[63px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#00b362] "
  }, formatPrice(discountedPrice)), /*#__PURE__*/React.createElement(SAR, {
    className: "relative top-1 text-[#00b362] px-1"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-[#fe561c] text-white text-xss flex items-center justify-start gap-2 px-2 h-6",
    dir: lang === 'ar' ? 'rtl' : 'ltr'
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--acute-outline-rounded",
    className: "text-white w-4.5 h-2.5 en:scale-x-[-1]"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ar:order-2 en:order-2"
  }, tShort("promo/time_remaining_for_discount", {
    ns: "web_promo"
  })), /*#__PURE__*/React.createElement(Countdown, {
    date: promoCode.expires_at,
    daysInHours: true,
    className: "ar:order-last en:order-first",
    onComplete: function onComplete() {
      //hide poup
      setIsVisible(false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bg-[#3c56d4] rounded-lg text-white ar:text-right en:text-left relative flex flex-col",
    dir: lang === 'ar' ? 'rtl' : 'ltr',
    style: {
      width: "369px",
      height: "172px",
      marginTop: "-48px",
      paddingTop: "58px",
      // For overlap
      paddingLeft: "20px",
      // p-5 equivalent
      paddingRight: "20px",
      // p-5 equivalent
      paddingBottom: "20px" // p-5 equivalent
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "text-xl mb-2"
  }, tShort("promo/did_you_like_this_car", {
    ns: "web_promo"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-sm mb-3 font-normal no-currency-icon"
  }, tShort("promo/special_discount_for_you", {
    ns: "web_promo"
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, " " + formatPrice(promoCode.discount_amount)), /*#__PURE__*/React.createElement(SAR, {
    className: "relative top-0.5"
  }), tShort("promo/riyals_on_this_car", {
    ns: "web_promo"
  })), " "), /*#__PURE__*/React.createElement("div", {
    className: "mt-auto"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleBookNow,
    className: "w-full mx-auto bg-white text-3 text-[#3c56d4] rounded font-bold border-0 h-8 cursor-pointer"
  }, tShort("promo/book_now", {
    ns: "web_promo"
  }))))))));
};
export default PromoPopup;